import "../style.css";
import React from "react";
import PanelContent from "../components/PanelContent";

export default function Avocats() {
  return (
    <PanelContent
      id="avocats_panel"
      route="/avocats"
      frTitle= "Les Maîtres"
      enTitle = "The Masters"
      frSubtitle="Badinter et Bocquillon"
      enSubtitle = "Badinter and Bocquillon"
      frText="Personne ne veut défendre l'assassin du petit garçon de la mort. Tout le monde soutient la peine capitale. Maître Bocquillon est le seul à tenter d'éviter cette sanction à Patrick Henry. Il fait appel à Maître Robert Badinter, persuadé que la peine de mort n'a plus sa raison d'être, et qu'il faut faire de ce procès une lutte contre cette sentence."
      enText = "No one wants to defend the murderer of the little boy from death. Everyone supports the death penalty. Maître Bocquillon is the only one attempting to save Patrick Henry from this punishment. He calls upon Maître Robert Badinter, who is convinced that the death penalty is obsolete and that this trial should become a fight against this sentence."
      frLeftButton=""
      enLeftButton = ""
      frRightButton="ÉTAPE SUIVANTE"
      enRightButton = "NEXT STEP"
      prev="/enigme"
      next="/manifestants"
    />
  );
}
